import React, { useState, Suspense } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../utils/database";
import { Box, Button, TextField, Typography } from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
}

function About(props: TabPanelProps) {
  const { children, ...other } = props;
  const [email, setEmail] = useState("");

  return (
    <>
      <Typography
        variant="h4"
        sx={{
          width: { xs: "90%", md: "60%" },
          mt: 5,
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        Robotics101
      </Typography>
      <Typography
        variant="h6"
        sx={{
          width: { xs: "90%", md: "60%" },
          mt: 1,
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        Making Robotics Easy to Learn through Visualization
      </Typography>
      <Typography
        sx={{
          width: { xs: "90%", md: "60%" },
          margin: 5,
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        Hi, I'm a Digital IC Engineer based in Taiwan. While studying robotics
        independently, I found that understanding mathematics solely through
        text was quite challenging. Consequently, I developed{" "}
        <b>Robotics101, a website focused on robotic visualization</b>. Its
        purpose is to assist individuals like myself in grasping robotics
        concepts quickly.
        <br />
        <br />
        The primary aim of this platform is to{" "}
        <b>make learning robotics easier through visualization</b>. Most of the
        content follows the book:{" "}
        <a href="https://link.springer.com/book/10.1007/978-1-84628-642-1">
          Robotics Modelling, Planning and Control
        </a>
        . If you are reading this book, this website is definitely suitable for
        you.
        <br />
        <br />
        I've created a{" "}
        <a href="https://discord.gg/TfwZ3hH2D2">Discord channel</a> dedicated to
        robotic learning. You're invited to join and share your robotic
        learning/teaching experiences with fellow enthusiasts from around the
        world. Also, I wish you could tell me what I can do on this website to
        make robotic learning easier. Let's connect, learn, and grow together in
        the fascinating world of robotics!
        <br />
        <br />
        Or you can leave your email below to receice latest updata.
      </Typography>
      <Box>
        <TextField
          id="outlined-basic"
          label="email"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button
          variant="contained"
          sx={{ margin: 1 }}
          onClick={async () => {
            try {
              console.log(db);
              const docRef = await addDoc(collection(db, "emails"), {
                email,
              });
              console.log("Document written with ID: ", docRef.id);
            } catch (e) {
              console.error("Error adding document: ", e);
            }
          }}
        >
          Submit
        </Button>
      </Box>
    </>
  );
}

export default About;
